import React, { Component } from "react";
import {
	Form,
	Select,
	Tabs,
	Radio,
	Row,
	Col,
	Button,
	Input,
	InputNumber,
	Checkbox
} from "antd";
import { inject, observer } from "mobx-react";

const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const tailFormItemLayout = {
	wrapperCol: {
		xs: {
			span: 24,
			offset: 0
		},
		sm: {
			span: 20,
			offset: 4
		}
	}
};

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 4 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 20 }
	}
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class VerificationInfoForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll({ force: true }, callback);
	};

	spamFolderValidator = (rule, value, callback) => {
		// console.log("Validating", value);
		// if (value == null || value == undefined) {
		// 	callback("Required");
		// }
		let protocol = this.props.form.getFieldValue("verificationInfo.mailProtocol");
		if (protocol == "imap") {
			let checkSpamFolder = this.props.form.getFieldValue(`verificationInfo.checkSpamFolder`);
			if (checkSpamFolder) {
				if (!value) {
					callback("Spam folder name is required");
				}
			}
		}
		callback();		
	};

	render() {
		const ui = this.props.ui;

		const getFieldDecorator = this.props.getFieldDecorator;
		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
				sm: { span: 4 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 20 }
			}
		};
		const buttonItemLayout = {
			wrapperCol: { span: 18, offset: 4 }
		};

		let manualSection = "";
		if (this.props.form.getFieldValue("emailSource") === "MANUAL") {

			let protocol = this.props.form.getFieldValue("verificationInfo.mailProtocol");
			let spamFolderDisplay = "none";
			if (protocol == "imap") {
				spamFolderDisplay = "block";
			} else {
				spamFolderDisplay = "none";
			}

			
			manualSection = (
				<Row>
					<FormItem {...buttonItemLayout}>
						<Button
							type="primary"
							onClick={this.props.downloadRankerXEmail}
							loading={ui.downloadingRankerXEmail}
							disabled={!ui.editing}
						>
							Download RankerX Mail
						</Button>
						{' '}
						<Button
							type="primary"
							onClick={this.props.downloadEmailFromEmailList}
							loading={ui.downloadingEmailFromEmailList}
							disabled={!ui.editing}
						>
							Download From Email List
						</Button>
						{' '}
						<Button
							type="primary"
							onClick={this.props.testEmail}
							loading={ui.testingEmail}
						>
							Test Email
						</Button>
					</FormItem>
					<FormItem label="Server Address" {...formItemLayout}>
						{this.props.form.getFieldDecorator("verificationInfo.emailServer", {
							rules: [
								{
									required: true,
									message: "Please enter server address"
								}
							]
						})(<Input type="text" disabled={!ui.editing} />)}
					</FormItem>
					<FormItem label="Server Port" {...formItemLayout}>
						{this.props.form.getFieldDecorator(
							"verificationInfo.emailServerPort",
							{
								rules: [
									{
										required: true,
										message: "Please enter the server port"
									}
								]
							}
						)(<InputNumber disabled={!ui.editing} />)}
					</FormItem>
					<FormItem
						label="Server Type"
						{...formItemLayout}
						help="Email Server Type"
					>
						{this.props.form.getFieldDecorator(
							"verificationInfo.mailProtocol",
							{
								rules: [
									{
										required: true,
										message: "Please select email protocol"
									}
								]
							}
						)(
							<Select
								style={{ width: 160 }}
								placeholder="Select an email protocol"
								disabled={!ui.editing}
							>
								<Option value="pop3">POP3</Option>
								<Option value="imap">IMAP</Option>
							</Select>
						)}
					</FormItem>
					<FormItem
						label="Email Address"
						{...formItemLayout}
						help="Enter your verification email address"
					>
						{this.props.form.getFieldDecorator("verificationInfo.emailAddress", {
							rules: [
								{
									required: true,
									message: "Please enter your verification email"
								}
							]
						})(<Input type="email" disabled={!ui.editing} />)}
					</FormItem>
					<FormItem
						label="Email Login"
						{...formItemLayout}
						extra="Enter your email login"
					>
						{this.props.form.getFieldDecorator(
							"verificationInfo.emailLogin",
							{
								rules: [
									{
										required: true,
										message: "Please enter your email login"
									}
								]
							}
						)(<Input type="email" disabled={!ui.editing} />)}
					</FormItem>
					<FormItem label="Password" {...formItemLayout}>
						{this.props.form.getFieldDecorator(
							"verificationInfo.emailPassword",
							{
								rules: [
									{
										required: true,
										message: "Email password is required"
									}
								]
							}
						)(<Input type="password" disabled={!ui.editing} />)}
					</FormItem>
					<FormItem {...tailFormItemLayout} style={{ marginBottom: 0 }}>
						{this.props.form.getFieldDecorator("verificationInfo.SSL", {
							valuePropName: "checked",
							// rules: [
							// 	{
							// 		required: true,
							// 		message: "Use SSL or not"
							// 	}
							// ]
						})(<Checkbox disabled={!ui.editing}>Use SSL</Checkbox>)}
					</FormItem>
					<FormItem {...tailFormItemLayout} style={{ marginBottom: 0, display: spamFolderDisplay }}>					
						<FormItem style={{ display: 'inline-block'}}>
							{this.props.form.getFieldDecorator("verificationInfo.checkSpamFolder", {
								valuePropName: "checked",
								initialValue: false
								// rules: [
								// 	{
								// 		required: true,
								// 		message: "Use SSL or not"
								// 	}
								// ]
							})(<Checkbox disabled={!ui.editing}>Check Spam Folder</Checkbox>)}
						</FormItem>
						<FormItem label="Name" {...formItemLayout} style={{ display: 'inline-block', width: 300 }}>
							{this.props.form.getFieldDecorator("verificationInfo.spamFolderName", {
								rules: [
									{
										validator: this.spamFolderValidator,
										message: "Spam folder name is required"
									}
								]
							})(<Input disabled={!ui.editing} type="text" />)}
						</FormItem>
				</FormItem>						
				</Row>
			);
		}

		return (
			<div>
				<Row>
					<Col span={18}>
						<Row>
							<FormItem {...buttonItemLayout}>
								{this.props.form.getFieldDecorator("emailSource")(
									<RadioGroup disabled={!ui.editing}>
										<RadioButton value="MANUAL">Manual</RadioButton>
										<RadioButton value="RANKERX">
											Auto download RankerX Mail
										</RadioButton>
										<RadioButton value="LIST">
											Auto download from Email List
										</RadioButton>
									</RadioGroup>
								)}
							</FormItem>
						</Row>
						{manualSection}
					</Col>
				</Row>
			</div>
		);
	}
}

@inject("rootStore")
@observer
class VerificationInfoTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		acProjectStore.formChanged(changedFields);
	};
	mapPropsToFields = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		const stateForm = acProjectStore.stateForm;

		return {			
			emailSource: Form.createFormField(stateForm.emailSource),
			verificationInfo: {
				emailServer: Form.createFormField(
					stateForm.verificationInfo.emailServer
				),
				emailServerPort: Form.createFormField(
					stateForm.verificationInfo.emailServerPort
				),
				emailAddress: Form.createFormField(
					stateForm.verificationInfo.emailAddress
				),
				emailLogin: Form.createFormField(
					stateForm.verificationInfo.emailLogin
				),				
				emailPassword: Form.createFormField(
					stateForm.verificationInfo.emailPassword
				),
				mailProtocol: Form.createFormField(
					stateForm.verificationInfo.mailProtocol
				),
				SSL: Form.createFormField(stateForm.verificationInfo.SSL),
				spamFolderName: Form.createFormField(
					stateForm.verificationInfo.spamFolderName
				),
				checkSpamFolder: Form.createFormField(
					stateForm.verificationInfo.checkSpamFolder
				)
			}
		};
	};

	downloadRankerXEmail = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		acProjectStore.downloadRankerXEmail();
	};

	downloadEmailFromEmailList = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.downloadEmailFromEmailList();
	};

	testEmail = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.testEmail();
	};


	render() {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		const ui = acProjectStore.ui;

		return (
			<VerificationInfoForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
				ui={ui}
				testEmail={this.testEmail}
				downloadRankerXEmail={this.downloadRankerXEmail}
				downloadEmailFromEmailList={this.downloadEmailFromEmailList}
				wrappedComponentRef={internalForm => {
					this.internalForm = internalForm;
				}}
			/>
		);
	}
}

export default VerificationInfoTab;
